import React from 'react';
import {useSidebar} from '@src/components/shadcn/sidebar';
import cn from '@src/util/cnHelper';

export const PageWrapper: React.FC<React.PropsWithChildren> = ({children}) => {
  return <div className="flex flex-auto overflow-hidden flex-col md:flex-row">{children}</div>;
};

export const ContentWraper: React.FC<React.PropsWithChildren> = ({children}) => {
  const {openMobile} = useSidebar();
  return (
    <div
      className={cn(
        'min-w-0 max-w-full flex-1 w-full fixed top-12 h-[calc(100%-48px)] md:static md:top-0 md:h-screen',
        openMobile && 'overflow-hidden md:overflow-visible'
      )}
    >
      {children}
    </div>
  );
};

export const NavWrapper: React.FC<React.PropsWithChildren> = ({children}) => {
  return (
    <div className="flex flex-wrap h-12 w-full fixed inset-0 md:static md:w-[--sidebar-width] md:border-0 md:border-r md:border-peppercorn-200">
      {children}
    </div>
  );
};
